import { collection, doc, getDoc, where } from "firebase/firestore";
import { db } from "../../firebase";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const GetSingleLeadData = async (leadId) => {
  /**
   * input: null
   * output: lead object
   * description: fetches Single lead
   */

  try {
    let leadsCollection = await collection(db, "leads");
    let leadDocument = await doc(leadsCollection, leadId);
    const leadSnapshot = await getDoc(
      leadDocument,
      where("bid", "==", getLocalStorageItem("bid")),
      where("is_deleted", "==", false)
    );

    let lead = { ...leadSnapshot.data(), id: leadSnapshot.id };
    return lead;
  } catch (error) {
    console.log(error);
  }
};

export default GetSingleLeadData;
